import React, { ReactElement, ReactNode } from "react";

import { ProductTileModel } from "@api/mappers/products.mapper";

import { stringToBoolean } from "@utils/attributes";

import { ProductTileRenditions } from "@components/Product/ProductImage/mappedRenditions";
import { ProductTileLayout } from "@components/Product/ProductTile/productTile.config";
import { ProductTile } from "@components/Product/ProductTile/productTile.container";

export type ProductTileAdapterProps = {
    showButton: string | boolean;
    showCategoryLink: string | boolean;
    allowInstantAddToCart: string;
    amountOfFeatures: number;
    useInsidePadding: string | boolean;
    sku: string;
    product: ProductTileModel;
    extraButtons?: () => ReactNode;
    cqDataPath?: string;
};

const ProductTileAdapter = ({
    showButton,
    amountOfFeatures,
    showCategoryLink,
    allowInstantAddToCart,
    useInsidePadding,
    sku,
    product,
    extraButtons,
    cqDataPath,
}: ProductTileAdapterProps): ReactElement | null => {
    const categoryLink = stringToBoolean(showCategoryLink.toString());
    const button = stringToBoolean(showButton.toString());

    return (
        <ProductTile
            sku={sku}
            product={product}
            allowInstantAddToCart={allowInstantAddToCart}
            extraButtons={extraButtons}
            cqDataPath={cqDataPath}
            productTileConfig={{
                tilePadding: stringToBoolean(`${useInsidePadding}`),
                imageRenditions: ProductTileRenditions,
                amountOfFeatures: amountOfFeatures,
                components: ProductTileLayout.AEM(button, categoryLink),
            }}
        />
    );
};

export { ProductTileAdapter };
